import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ReportFilesService } from '../service/report-files.service';
import { RIGHT_NAV_TRANSLATION_BASE_PATH } from '~core/components/right-nav-breadcrumb-constants';
import { TranslatePipe } from '~shared/pipes/translate.pipe';
import { AppState } from '~core/states/app/app.state';
import { SidebarState } from '~core/states/sidebar/sidebar.state';
import { PermitDataService } from '~shared/services/apiPermitController';

export const reportFilesResolver: ResolveFn<any> = (route, state) => {
  const translate = inject(TranslatePipe);
  const appState = inject(AppState);
  const sidebarState = inject(SidebarState);

  const isReportUpload = sidebarState.get('isReportUpload');

  const translatePath = isReportUpload ? `${RIGHT_NAV_TRANSLATION_BASE_PATH}.DisplayName.Report Files` : `${RIGHT_NAV_TRANSLATION_BASE_PATH}.DisplayName.Import Files`;
      
  const translatedTitle = translate.transform(translatePath);
  appState.set('childPageTitle', '');
  
  appState.set('pageTitle', translatedTitle);
  if (isReportUpload) {
    return inject(ReportFilesService).getReportFiles('Facility');
  } else { 
    return inject(PermitDataService).getImportFilesByFolderLevel();
  }
};
